import { loadConfig } from '@api/api';
import axios, { AxiosResponse } from 'axios';
import type { ServerCommonConfig } from 'config/config';

async function getConfigApi() {
  const BASE_URL = await loadConfig();
  return `${BASE_URL}/api/v1/utilities/capture/config`;
}

export async function uploadconfig(
  accessToken: string,
  params: ServerCommonConfig,
){
  console.log(accessToken)
  const url = await getConfigApi();

  const response: AxiosResponse = await axios
    .patch(`${url}`,
      params,
      {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`,
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  return response;
}

export async function getServerConfig(accessToken: string){
  const url = await getConfigApi();

  const res: AxiosResponse = await axios
    .get(`${url}`, {
      headers: {
        Accept: '*/*',
        Authorization: `Bearer ${accessToken}`
      },
    })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });

  const status = res.status == 201 || res.status == 200;
  return [status, status ? res.data : res.status];
}
